import { createFileRoute } from "@tanstack/react-router";

import { HelpPage } from "../../features/help/HelpPage";

/** `q`, from the assistant's link to an answer, opens the help searched for its question. */
export const Route = createFileRoute("/_app/help")({
  validateSearch: (search: Record<string, unknown>): { q?: string } =>
    typeof search["q"] === "string" && search["q"] !== "" ? { q: search["q"] } : {},
  component: function Help() {
    return <HelpPage initialQuery={Route.useSearch().q ?? ""} />;
  },
});
